module.exports = __webpack_public_path__ + "static/genio-login-ee161c433272e93bda804c3863f07c86.png";